import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/mensagens")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="contacts"
      label="Mensagens"
      idColumn="id"
      
      fields={[
        { name: "name", label: "Nome", type: "text", required: true },
        { name: "email", label: "E-mail", type: "text", required: true },
        { name: "phone", label: "Telefone", type: "text" },
        { name: "subject", label: "Assunto", type: "text" },
        { name: "message", label: "Mensagem", type: "textarea" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Nova", value: "new" },
            { label: "Lida", value: "read" },
            { label: "Respondida", value: "replied" },
          ],
        },
      ]}
      columns={[
        { key: "name", label: "Nome" },
        { key: "email", label: "E-mail" },
        { key: "subject", label: "Assunto" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
